import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product, onProductClick }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e?.stopPropagation();
    console.log('🛒 ProductCard - Ajout au panier:', product?.name);
    if (!product) {
      console.error('❌ Produit invalide dans ProductCard');
      return;
    }
    // Vérifier si le produit est en rupture de stock
    if (product.stock === 0) {
      console.warn('⚠️ Produit en rupture de stock:', product.name);
      return;
    }
    addToCart(product, 1);
  };

  const handleCardClick = (e) => {
    // Ne pas ouvrir la modal si on clique sur un bouton ou un élément interactif
    if (e.target.closest('button') || e.target.closest('.product-actions')) {
      return;
    }
    if (onProductClick) {
      onProductClick(product);
    }
  };

  return (
    <div className="product-card" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      <div className="product-image">
        <img src={product.image} alt={`${product.name} - ${product.category} bio`} loading="lazy" />
        {product.featured && <span className="featured-badge">Coup de cœur</span>}
      </div>
      
      <div className="product-info">
        <div className="product-category">{product.category}</div>
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.description}</p>
        
        <div className="product-footer">
          <div className="product-price">
            <span className="price">{product.price.toFixed(2)}€</span>
            <span className="unit">/ {product.unit}</span>
          </div>
          
          <div className="product-actions">
            <div className="stock-info">
              <span className={`stock ${product.stock < 5 ? 'low' : ''}`}>
                {product.stock > 0 ? `${product.stock} en stock` : 'Rupture'}
              </span>
              {product.stock < 5 && product.stock > 0 && (
                <span className="stock-warning">⚠️ Stock faible</span>
              )}
            </div>
            <button 
              className="add-to-cart-btn"
              onClick={handleAddToCart}
              disabled={product.stock === 0}
              title={product.stock === 0 ? 'Produit en rupture de stock' : 'Ajouter au panier'}
            >
              <ShoppingCart size={12} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;